import { message, notification, Form, Input, Button } from "antd";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { callUpdatePassword } from "../../../config/api";
import Loading from "../../../components/Loading/Loading";

function ChangePassword() {
  const [form] = Form.useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const user = useSelector((state: any) => state.account.user);
  const onFinish = async (values: any) => {
    const { oldPassword, newPassword, confirmNewPassword } = values;
    // Kiểm tra mật khẩu mới và xác nhận mật khẩu
    if (newPassword !== confirmNewPassword) {
      message.error("Mật khẩu mới và xác nhận mật khẩu không trùng khớp.");
      return;
    }

    setIsSubmit(true);
    const res = await callUpdatePassword(oldPassword, newPassword);
    if (res && res.data) {
      message.success("Cập nhật mật khẩu thành công");
      form.setFieldValue("oldPassword", "");
      form.setFieldValue("newPassword", "");
      form.setFieldValue("confirmNewPassword", "");
    } else {
      notification.error({
        message: "Đã có lỗi xảy ra",
        description: res.message,
      });
    }
    setIsSubmit(false);
  };

  useEffect(() => {
    form.setFieldsValue(user);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.id]);

  return (
    <div>
      {" "}
      <Form
        form={form}
        name="basic"
        style={{ maxWidth: 600, margin: "0 auto" }}
        onFinish={onFinish}
        autoComplete="off">
        <Form.Item
          labelCol={{ span: 24 }} //whole column
          label="Email"
          name="email"
          rules={[{ required: true, message: "Email không được để trống!" }]}>
          <Input disabled />
        </Form.Item>

        <Form.Item
          labelCol={{ span: 24 }} //whole column
          label="Mật khẩu cũ"
          name="oldPassword"
          rules={[
            { required: true, message: "Mật khẩu không được để trống!" },
          ]}>
          <Input.Password />
        </Form.Item>
        <Form.Item
          labelCol={{ span: 24 }} //whole column
          label="Mật khẩu mới"
          name="newPassword"
          rules={[
            { required: true, message: "Mật khẩu không được để trống!" },
          ]}>
          <Input.Password />
        </Form.Item>
        <Form.Item
          labelCol={{ span: 24 }} //whole column
          label="Xác nhận mật khẩu mới"
          name="confirmNewPassword"
          rules={[
            { required: true, message: "Mật khẩu không được để trống!" },
          ]}>
          <Input.Password />
        </Form.Item>
        <Button type="primary" htmlType="submit">
          Xác nhận
        </Button>
      </Form>
      {isSubmit && <Loading />}
    </div>
  );
}

export default ChangePassword;
